import React, { useEffect, useRef } from 'react';
import Utils from '../utils';

// Renders one row of the combined "names only" search: the entity type and id,
// followed by the name in the input language and each output language.
function NameResult({ item, index, term }) {
  const componentRef = useRef(null);

  useEffect(() => {
    // Wire up the shared highlight/copy behavior for this row only
    if (componentRef.current) {
      Utils.highlightSearchTerm(componentRef.current, term);
      Utils.doCH(componentRef.current);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <li
      className={`result-item ${item.outputLanguage2 ? 'multi' : ''}`}
      data-id={item.id}
      key={index}
      ref={componentRef}
    >
      <ul className="info-container" data-id={item.id}>
        <li>
          <span className={`result-type-badge type-${(item.resultType || '').toLowerCase()}`}>
            {item.resultType}
          </span>
        </li>
        <li>
          <span>{item.id}</span>
        </li>
      </ul>
      <ul className="language-container" data-id={item.id}>
        <li>
          <center>
            <strong>
              <span data-id={1} className="item-name class-1 highlightable">
                {item.inputLanguage && item.inputLanguage.name}
              </span>
            </strong>
          </center>
        </li>
      </ul>
      <ul className="language-container" data-id={item.id}>
        <li>
          <center>
            <strong>
              <span data-id={1} className="item-name class-1 highlightable">
                {item.outputLanguage && item.outputLanguage.name}
              </span>
            </strong>
          </center>
        </li>
      </ul>
      {item.outputLanguage2 ? (
        <ul className="language-container" data-id={item.id}>
          <li>
            <center>
              <strong>
                <span data-id={1} className="item-name class-1 highlightable">
                  {item.outputLanguage2 && item.outputLanguage2.name}
                </span>
              </strong>
            </center>
          </li>
        </ul>
      ) : null}
    </li>
  );
}

export default NameResult;
